document.addEventListener('DOMContentLoaded', () => {
    const mapElement = document.getElementById('distributor-map');
    const searchInput = document.getElementById('distributor-search-input');
    const listElement = document.getElementById('distributor-list');

    const noFoundText = listElement.dataset.noFound

    if (!mapElement) return;

    // Configuration
    // Note: We need a valid Storefront Access Token. 
    // If the section setting is empty, we might need a fallback.
    // We can attempt to grab it from a meta tag if the theme injects one, usually not.
    // For this implementation, we will try to query the public API if available or warn.
    const STOREFRONT_TOKEN = 'dd4d4ddf4b2331581457189f9c7cb387'; // Public demo token (Shopify Supply) usually works for simple tests, BUT we need YOUR store's token.
    // Actually, we will query the current domains API using the Fetch API.
    // The user needs to supply a token in the section settings effectively.
    // Let's grab the token from the liquid variable we injected or data attribute? 
    // We didn't inject it yet. Let's assume we pass it or use a simpler method.
    // Better approach for now: Since we can't easily get a token without user input, 
    // let's MOCK the data first to prove it works, then switch to API.
    // WAIT, user agreed to "Locations API". I should prompt them to add the token.

    // Let's proceed with the fetch logic but handle errors gracefully.

    let map;
    let markers = [];
    let locationsData = [];
    let selectedMarkerIndex = null; // Track selected marker

    // Custom Icons - URLs injected by Liquid template
    const normalIcon = L.icon({
        iconUrl: window.MAP_ICON_NORMAL,
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -40]
    });

    const selectedIcon = L.icon({
        iconUrl: window.MAP_ICON_SELECTED,
        iconSize: [50, 50],
        iconAnchor: [25, 50],
        popupAnchor: [0, -50]
    });

    const selfLocationIcon = L.icon({
        iconUrl: window.MAP_ICON_LOCATION_SELF,
        iconSize: [50, 50],
        iconAnchor: [25, 25], // Center anchor for a location dot/circle usually, or adjust if pin
        popupAnchor: [0, -25]
    });

    // Initialize Map
    function initMap() {
        // Default Center (New York)
        // Disable default zoom control to move it
        // Disable default attribution control
        map = L.map('distributor-map', {
            zoomControl: false,
            attributionControl: false,
            maxBounds: [[-90, -Infinity], [90, Infinity]], // 仅限制纬度-90到90，经度不限制
            maxBoundsViscosity: 1.0, // 1.0表示完全卡住
            minZoom: 2,// 防止缩得太小露出灰色背景
            worldCopyJump: true // 允许经度循环（世界地图复制跳转）
        }).setView([40.7128, -74.0060], 4); // Zoom level 4 fits US better for initial view

        // In Leaflet 'bottomright' corner, controls stack upwards.
        // The first control added sits at the very bottom.
        // We want: Zoom (Top) -> Locate (Bottom)
        // So we must add Locate FIRST (bottom), then Zoom (top).

        // 1. Add Custom "Locate Me" Button (Bottom)
        addLocateControl();

        // 2. Add Zoom Control (Top)
        L.control.zoom({
            position: 'bottomright'
        }).addTo(map);

        // Restore Tile Layer (Leaflet + OSM)
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            maxZoom: 19,
            attribution: '', // Empty attribution as requested
            detectRetina: false,
            tileSize: 256,
            zoomOffset: 0
        }).addTo(map);
    }

    function addLocateControl() {
        const LocateControl = L.Control.extend({
            options: { position: 'bottomright' },
            onAdd: function (map) {
                const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
                // Styles moved to CSS for scaling support
                container.title = "Show my location";

                // SVG Icon for Location (Target Crosshair Style)
                container.innerHTML = `
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="2" x2="12" y2="6"></line>
                    <line x1="12" y1="18" x2="12" y2="22"></line>
                    <line x1="2" y1="12" x2="6" y2="12"></line>
                    <line x1="18" y1="12" x2="22" y2="12"></line>
                </svg>`;

                container.onclick = function () {
                    map.locate({ setView: true, maxZoom: 12 });
                }
                return container;
            }
        });
        map.addControl(new LocateControl());

        // Handle location found
        map.on('locationfound', function (e) {
            // Remove existing self marker if any (need to track it globally if we want to update)
            // For now just add new one
            L.marker(e.latlng, { icon: selfLocationIcon })
                .addTo(map)
                .bindPopup("You are here")
                .openPopup();
        });

        // Handle location error
        map.on('locationerror', function (e) {
            alert(e.message);
        });
    }

    // Fetch Locations
    async function fetchLocations() {
        try {
            // Use data injected by Liquid template from Theme Editor blocks
            if (window.DISTRIBUTORS_DATA && window.DISTRIBUTORS_DATA.length > 0) {
                locationsData = window.DISTRIBUTORS_DATA;
                renderList(locationsData);
                renderMarkers(locationsData);
            } else {
                listElement.innerHTML = `<div class="distributor-loading">${noFoundText}</div>`;
            }
        } catch (e) {
            listElement.innerHTML = `<div class="distributor-loading">${noFoundText}</div>`;
        }
    }

    function renderList(locations) {
        listElement.innerHTML = '';
        if (locations.length === 0) {
            listElement.innerHTML = `<div class="distributor-loading">${noFoundText}</div>`;
            return;
        }

        locations.forEach((loc, index) => {
            const item = document.createElement('div');
            item.className = 'distributor-item';
            // Use Global Icon URLs
            const phoneIcon = window.MAP_ICON_PHONE || '';
            const mailIcon = window.MAP_ICON_MAIL || '';
            const email = loc.email || 'info@meraki.home'; // Fallback

            item.innerHTML = `
                <div class="distributor-name">${loc.name}</div>
                <div class="distributor-address">${loc.address.city && loc.address.address1 ? loc.address.address1 + ',' : loc.address.address1} ${loc.address.province && loc.address.city ? loc.address.city + ',' : loc.address.city} ${loc.address.zip && loc.address.province ? loc.address.province + ',' : loc.address.province} ${loc.address.country && loc.address.zip ? loc.address.zip + ',' : loc.address.zip} ${loc.address.country}</div>
                <div class="distributor-divider">&nbsp;</div>
                ${loc.address.phone ? `
                <div class="distributor-contact-row">
                    <img src="${phoneIcon}" class="contact-icon" alt="Phone" />
                    <span class="distributor-phone">${loc.address.phone}</span>
                </div>` : ''}
                <div class="distributor-contact-row">
                    <img src="${mailIcon}" class="contact-icon" alt="Email" />
                    <span class="distributor-email">${email}</span>
                </div>
            `;

            item.addEventListener('click', () => {
                // If clicking the already-selected item, do nothing
                if (selectedMarkerIndex === index) {
                    return;
                }

                // Immediately update icon first for instant visual feedback
                const oldIndex = selectedMarkerIndex;
                selectedMarkerIndex = index;

                // Update all copies of this marker to selected icon and bring to front
                markers.filter((m, i) => Math.floor(i / 3) === index).forEach(m => {
                    m.setIcon(selectedIcon);
                    m.setZIndexOffset(1000); // Bring to front
                });

                // Reset previous selected marker (all copies) and reset z-index
                if (oldIndex !== null && oldIndex !== index) {
                    markers.filter((m, i) => Math.floor(i / 3) === oldIndex).forEach(m => {
                        m.setIcon(normalIcon);
                        m.setZIndexOffset(0); // Reset to default
                    });
                }

                // Highlight logic in list
                document.querySelectorAll('.distributor-item').forEach(el => el.classList.remove('active'));
                item.classList.add('active');

                // Map fly - faster animation
                if (loc.address.latitude && loc.address.longitude) {
                    map.flyTo([loc.address.latitude, loc.address.longitude], 15, {
                        duration: 0.8
                    });
                    // Close all existing popups before opening new one
                    map.eachLayer((layer) => {
                        if (layer instanceof L.Popup) {
                            map.closePopup(layer);
                        }
                    });
                    // Open popup on the first copy (index * 3 + 1 for the center copy at offset 0)
                    const centerMarkerIndex = index * 3 + 1;
                    if (markers[centerMarkerIndex]) {
                        markers[centerMarkerIndex].openPopup();
                    }
                }
            });

            listElement.appendChild(item);
        });
    }

    function renderMarkers(locations) {
        // Clear existing
        markers.forEach(m => map.removeLayer(m));
        markers = [];
        selectedMarkerIndex = null; // Reset selection when re-rendering

        locations.forEach((loc, index) => {
            if (loc.address.latitude && loc.address.longitude) {
                // 为每个地点创建3个副本，支持经度循环（-360, 0, +360度）
                const offsets = [-360, 0, 360];

                offsets.forEach(offset => {
                    const marker = L.marker([loc.address.latitude, loc.address.longitude + offset], {
                        icon: normalIcon,
                        riseOnHover: false // Disable hover animation
                    })
                        .addTo(map)
                        .bindPopup(`<b>${loc.name}</b><br>${loc.address.address1}<br>${loc.address.phone || ''}`, {
                            closeButton: true,
                            autoClose: true,
                            closeOnClick: false,
                            className: 'custom-popup',
                            autoPan: false // 禁用自动寻心，防止与 flyTo 冲突
                        });


                    // Click marker to select
                    marker.on('click', (e) => {
                        // If clicking the already-selected marker, do nothing
                        if (selectedMarkerIndex === index) {
                            return;
                        }

                        // Close all popups first to prevent multiple popups
                        map.eachLayer((layer) => {
                            if (layer instanceof L.Popup) {
                                map.closePopup(layer);
                            }
                        });

                        // Stop event propagation
                        L.DomEvent.stopPropagation(e);

                        // Immediately update icon first for instant visual feedback
                        const oldIndex = selectedMarkerIndex;
                        selectedMarkerIndex = index;

                        // Update all copies of this marker to selected icon and bring to front
                        markers.filter((m, i) => Math.floor(i / 3) === index).forEach(m => {
                            m.setIcon(selectedIcon);
                            m.setZIndexOffset(1000); // Bring to front
                        });

                        // Reset previous selected marker (all copies) and reset z-index
                        if (oldIndex !== null && oldIndex !== index) {
                            markers.filter((m, i) => Math.floor(i / 3) === oldIndex).forEach(m => {
                                m.setIcon(normalIcon);
                                m.setZIndexOffset(0); // Reset to default
                            });
                        }

                        // Highlight in list
                        document.querySelectorAll('.distributor-item').forEach(el => el.classList.remove('active'));
                        const listItems = document.querySelectorAll('.distributor-item');
                        if (listItems[index]) {
                            listItems[index].classList.add('active');
                        }

                        // Scroll highlighted item into view
                        if (listItems[index]) {
                            listItems[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        }

                        // Open popup after icon change (without animation)
                        setTimeout(() => {
                            marker.openPopup(); // Open the popup of the clicked marker
                        }, 0);
                    });

                    markers.push(marker);
                });
            }
        });

        // Fit bounds
        if (markers.length > 0) {
            const group = new L.featureGroup(markers);
            map.fitBounds(group.getBounds().pad(0.05));
        }
    }

    function fuzzyMatchArrayWithAS(arr, regText = '') {
      let result = false
      const contiArr = regText.split('')
      const charCount = {};
      contiArr.forEach(char => {
        charCount[char] = (charCount[char] || 0) + 1;
      })
      const flags = `${'i'}`;
      
      let preCheck = '';
      Object.entries(charCount).forEach(([char, count]) => {
        preCheck += `(?=(.*${char}){${count}})`;
      });
      const pattern = `^${preCheck}.*$`;
      const asRegex = new RegExp(pattern, flags);

      if (!Array.isArray(arr)) {
        return result
      }

      arr.forEach((item, index) => {
        const normalizedItem = (item || '').trim();
        if (asRegex.test(normalizedItem)) {
          result = true;
        }
      });

      return result;
    }

    // Search Filter
    searchInput.addEventListener('input', (e) => {
        const term = e.target.value.toLowerCase();
        const filtered = locationsData.filter(loc => {
            const matchName = loc.name.toLowerCase().includes(term);
            // const matchCity = loc.address.city.toLowerCase().includes(term);
            const matchCountry = fuzzyMatchArrayWithAS([`${loc.address.country}`], term);
            const matchZip = loc.address.zip.toLowerCase().includes(term);
            return matchName || matchCountry || matchZip;
        });
        renderList(filtered);
        renderMarkers(filtered);
    });

    // Init
    initMap();
    fetchLocations();

    // Handle Window Resize to fix grey areas when container size changes
    window.addEventListener('resize', () => {
        if (map) {
            setTimeout(() => {
                map.invalidateSize();
                // Re-fit bounds after resize/show
                if (markers.length > 0) {
                    const group = new L.featureGroup(markers);
                    map.fitBounds(group.getBounds().pad(0.05));
                }
            }, 250);
        }
    });

    // Initial fix for dynamic CSS loading
    setTimeout(() => {
        if (map) map.invalidateSize();
    }, 500);

});
